module.exports = __webpack_public_path__ + "img/basket.60c6917b.svg";